import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../_store";
import { useEffect, useMemo } from "react";

const useManagementUserAccessPermission = () => {
  const userAccessPermission = useSelector((state) => state.auth.AllmanagementUserAccessPermission);
  const user = useSelector((x) => x.auth.user);
  const dispatch = useDispatch();

  // 🚀 Auto-fetch only if empty
  useEffect(() => {
    if (user && (!userAccessPermission || userAccessPermission.length === 0) && user?.UserRoleID != 1) {
      dispatch(
        authActions.GetAllManagementUserAccessPermission({
          ManagementUserID: user.ManagementUserID,
          ManagementMenuID: 0,
        })
      );
    }
  }, [user, userAccessPermission, dispatch]);

  // ✅ Always returns data synchronously (from Redux)
  const getUserAccessPermission = (menuID = 0) => {
    if (!userAccessPermission) return [];
    const returndata = menuID == 0 ? userAccessPermission : userAccessPermission.filter(item => item?.MainMenuID === menuID);

    // ✅ If no permission found and user is ManagementUser (ID = 1), return []
    if (returndata?.length === 0 && user?.UserRoleID === 1) {
      return [];
    }
    // ✅ Otherwise, return actual permission data (or default with SubMenuActiveStatus = 0 if empty)
    return returndata?.length > 0 ? returndata : [{ SubMenuActiveStatus: 0 }];
  };


  const permissions = useMemo(() => {
    return {
      all: getUserAccessPermission(0),
      // DashboardAccessPermission: getUserAccessPermission(1),
      // DocumentsAccessPermission: getUserAccessPermission(2),
      //  LockdownAccessPermission: getUserAccessPermission(3),
      // RevenueReportingAccessPermission: getUserAccessPermission(4),
      // HousingAreasAccessPermission: getUserAccessPermission(5),
      // KiosksAccessPermission: getUserAccessPermission(6),
      InmateAccessPermission: getUserAccessPermission(7),
      PuAccessPermission: getUserAccessPermission(8),
      //  RequestsOrGrievancesAccessPermission: getUserAccessPermission(9),
      MessageAccessPermission: getUserAccessPermission(10),
      accessPermission: getUserAccessPermission(11),
      //  KeywordsAccessPermission: getUserAccessPermission(12),
      //  NoticesAccessPermission: getUserAccessPermission(13),
      // FacilityAccessPermission: getUserAccessPermission(14),
      UserAccessPermission: getUserAccessPermission(15),
      // RegisteredPublicUsersAccessPermission: getUserAccessPermission(26),
      // ReportingAccessPermission: getUserAccessPermission(27),
      // DndUsersAccessPermission: getUserAccessPermission(28),
      // InactiveKioskAccessPermission: getUserAccessPermission(29),
      PostalMailAccessPermission: getUserAccessPermission(30),
      // MaintenanceSchedulesAccessPermission: getUserAccessPermission(31),
      // PaymentReportAccessPermission: getUserAccessPermission(32),
      // IPActivityAccessPermission: getUserAccessPermission(33),
      // MyWindowAccessPermission: getUserAccessPermission(34),
      // KeywordSearchAccessPermission: getUserAccessPermission(35),
      // ConnectionRequestsAccessPermission: getUserAccessPermission(36),
    };
  }, [userAccessPermission]);

  return { getUserAccessPermission, ...permissions };
};

export default useManagementUserAccessPermission;
